import { Spinner } from "../ui/Spinner";
import { BrandTile } from "../ui/brand-mark";

// セッション復元中（AuthProvider ready=false）の最小表示。guide-app の Splash と同構成。
export function Splash() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-canvas text-muted">
      <BrandTile className="size-14" />
      <div className="eyebrow">Tokyo Signature Tours</div>
      <Spinner className="text-accent" />
    </div>
  );
}
